var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.3806,
    r: 20,
    fill: "#1F232F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9975 12.6726C18.4487 12.6726 16.9606 12.8256 15.5781 13.1074L15.472 13.129C13.8932 13.4503 12.8412 13.6645 11.9346 14.83C11.0378 15.9831 11.0383 17.3203 11.0391 19.3913V21.3706C11.0383 23.4416 11.0378 24.7788 11.9346 25.9319C12.8412 27.0974 13.8932 27.3115 15.472 27.6329L15.5781 27.6545C16.9606 27.9363 18.4487 28.0893 19.9975 28.0893C21.5463 28.0893 23.0343 27.9363 24.4168 27.6545L24.5229 27.6329C26.1018 27.3115 27.1538 27.0974 28.0603 25.9319C28.9572 24.7788 28.9567 23.4416 28.9558 21.3706V19.3913C28.9567 17.3203 28.9572 15.9831 28.0603 14.83C27.1538 13.6645 26.1018 13.4503 24.5229 13.129L24.4168 13.1074C23.0343 12.8256 21.5463 12.6726 19.9975 12.6726Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0083 18.0907C20.3666 17.7323 19.8417 17.4392 19.4096 17.2578C18.7071 16.963 17.9622 16.9391 17.3499 17.4408C16.9667 17.7548 16.8312 18.2043 16.7718 18.6574C16.6281 19.7528 16.6282 21.0096 16.7718 22.1045C16.8312 22.5575 16.9667 23.0071 17.3499 23.3211C17.9622 23.8228 18.7071 23.7989 19.4096 23.5041C19.8417 23.3227 20.3666 23.0296 21.0083 22.6712C21.5099 22.3911 22.0253 22.1224 22.4932 21.7859C22.8429 21.5345 23.1747 21.2229 23.2845 20.7685C23.3462 20.5134 23.3462 20.2484 23.2845 19.9934C23.1747 19.5389 22.8429 19.2274 22.4932 18.9759C22.0253 18.6395 21.5099 18.3708 21.0083 18.0907Z",
    fill: "#1F232F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f7ca09e355ad05cc94343947640b2d93.svg";
export { ForwardRef as ReactComponent };